import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IMG_FILE_EXTENSIONS, IMG_UPLOAD_ACCEPTS } from "../../../constants/HTML";
import API from "../../../API";
import { displayImageUploadErrorMessage } from "../../../swzutils";
import { Progress, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { listFormat } from "../../../util/FormatUtil";
import { ImageLoader } from "./ImageLoader";
let formattedExtensions = listFormat(IMG_FILE_EXTENSIONS.map(it => '.' + it));
const ImageFileUpload = ({ icon, instructions, contentsUri, onUploadComplete }) => {
    const [statePhotoContentsUri, setStatePhotoContentsUri] = useState(null);
    const [statePhotoDeleteUri, setStatePhotoDeleteUri] = useState(null);
    const [statePhotoUploadedFileId, setStatePhotoUploadedFileId] = useState();
    const [statePhotoUploadProgress, setStatePhotoUploadProgress] = useState();
    useEffect(() => {
        setStatePhotoContentsUri(contentsUri);
    }, [contentsUri]);
    return (_jsxs(Upload.Dragger, { name: "uploadFile", accept: IMG_UPLOAD_ACCEPTS, withCredentials: true, showUploadList: false, action: `${API.origin()}/admin/v1/files?mandateImage=true`, onChange: (info) => {
            const status = info.file.status;
            if (status === 'uploading') {
                setStatePhotoUploadProgress(info.file.percent ?? null);
            }
            if (status === 'done') {
                const response = info.file.response;
                setStatePhotoUploadProgress(null);
                setStatePhotoContentsUri(response.contentsUri);
                setStatePhotoDeleteUri(response.deleteUri);
                setStatePhotoUploadedFileId(response.id);
                onUploadComplete(response.id);
            }
            else if (status === 'error') {
                setStatePhotoUploadProgress(null);
                displayImageUploadErrorMessage(info.file);
            }
        }, children: [statePhotoContentsUri ?
                _jsx(ImageLoader, { src: `${API.origin()}${statePhotoContentsUri}` })
                :
                    _jsx("p", { className: "ant-upload-drag-icon", children: icon }), statePhotoUploadProgress ?
                _jsx(Progress, { percent: statePhotoUploadProgress, status: "active" })
                :
                    _jsxs("div", { className: "upload-instructions", children: [_jsx("p", { className: "ant-upload-text", children: "Click or drag an image in to this area to upload." }), instructions &&
                                _jsx("p", { className: "ant-upload-text", children: instructions }), _jsxs("p", { className: "ant-upload-hint", children: ["Only ", formattedExtensions, " files are supported"] })] })] }));
};
export default ImageFileUpload;
